import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import { FavoriteProvider } from "@sonic-equipment/ui";
import React from "react";
import { connect, ResolveThunks, useDispatch } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    return {
        signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
    };
};

const mapDispatchToProps = {};

type Props = ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export const ReduxFavoriteProvider = connect(
    mapStateToProps,
    mapDispatchToProps,
)(({ signInUrl }: Props) => {
    const dispatch = useDispatch();

    function resetWishListData() {
        dispatch({
            type: "Data/WishListLines/Reset",
        });
        dispatch({
            type: "Data/WishLists/Reset",
        });
    }
    return (
        <FavoriteProvider
            signInUrl={signInUrl || ""}
            onFavoriteListAdded={() => resetWishListData()}
            onFavoriteAdded={() => resetWishListData()}
            onFavoriteRemoved={() => resetWishListData()}
        />
    );
});
